import { Component, model, output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Button, Input } from "@malirang/front-share";

@Component({
    selector: "app-store-menu-form",
    templateUrl: "./store-menu-form.component.html",
    styleUrls: ["./store-menu-form.component.css"],
    imports: [CommonModule, Input, Button],
})
export class StoreMenuFormComponent {
    cancel = output<void>();
    submit = output<void>();

    value = model<string>("");
}
